import { gql } from '@apollo/client'
import fragments from 'graphql/fragments'

// remote queries
export const GET_ESOPS = gql`
  query Esops($projectId: ID!) {
    esops(projectId: $projectId) {
      ...EsopFragment
    }
  }
  ${fragments.esop}
`

// ########## Remotes #############################

// remote mutations
export const _ADD_ESOP = gql`
  mutation _AddEsop($projectId: ID!, $input: EsopInput!) {
    _addEsop(projectId: $projectId, esopInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const ADD_ESOP = gql`
  mutation AddEsop($projectId: ID!, $input: EsopInput!) {
    addEsop(projectId: $projectId, esopInput: $input) {
      ...EsopFragment
    }
  }
  ${fragments.esop}
`

export const _SAVE_ESOP = gql`
  mutation _SaveEsop($esopId: ID!, $input: EsopInput!) {
    _saveEsop(esopId: $esopId, esopInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _DELETE_ESOP = gql`
  mutation _DeleteEsop($esopId: ID!) {
    _deleteEsop(esopId: $esopId) {
      ...Project
    }
  }
  ${fragments.project}
`

const esopQueries = {
  getRemote: GET_ESOPS,
  addRemote: _ADD_ESOP,
  saveRemote: _SAVE_ESOP,
  deleteRemote: _DELETE_ESOP,
  saveOp: '_saveEsop',
  addOp: '_addEsop',
  deleteOp: '_deleteEsop',
}

export default esopQueries
